export default {"CellPast":"d","RangeSelected":"e","CellOccupied":"f","CellProjected":"g","CellSelected":"h","CellProjectStart":"i","CellProjectEnd":"j"}